import { createContext } from 'react';
import type { PrivateEventBus } from './private-event-bus';

/** Shared context — kept in its own module so the provider file can stay
 * component-only for React Fast Refresh. */
export const PrivateEventBusContext = createContext<PrivateEventBus | null>(null);
